import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CustomerOverViewService } from '~features/customer-overview/customer-overview.service';
import { ButtonsTranslations } from '~shared/components/buttons/buttons-translations.service';
import { Customer, Club } from '../../models';
import {
  CampaignService,
  ContactManagementService,
  CustomerService,
  InvoiceService,
  ReminderService,
  TixxConnectionService,
  TixxSelectSubmissionService,
  StorageService
} from '../../services';

/**
 * Shell that operates with a customer
 */
@UntilDestroy()
@Component({
  selector: 'app-customer-shell',
  templateUrl: './customer-shell.component.html'
})
export class CustomerShellComponent implements OnDestroy {
  public customer: Customer;
  public selectedClub: Club;

  constructor(
    private customerService: CustomerService,
    private campaignService: CampaignService,
    private storageService: StorageService,
    private submissionService: TixxSelectSubmissionService,
    private reminderService: ReminderService,
    private contactManagementService: ContactManagementService,
    public invoiceService: InvoiceService,
    public buttonsTranslations: ButtonsTranslations,
    public customerOverviewService: CustomerOverViewService,
    public router: Router,
    public tixxConnectionService: TixxConnectionService,
  ) {
    this.customerService.castSelectedCustomer.pipe(untilDestroyed(this))
      .subscribe(customer => this.customer = customer);
    this.storageService.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe(club => this.selectedClub = club);
  }

  public ngOnDestroy(): void {
    this.customerService.clearSelecterCustomer();
    this.campaignService.clearCampaignActivity();
    this.submissionService.setSubmissionsList(null);
    this.invoiceService.setInvoiceList(null);
    this.invoiceService.setReservationsList(null);
    this.invoiceService.setCancellationsList(null);
    this.reminderService.setReminderList(null);
    this.contactManagementService.clearContactList();
  }

  /**
   * Open the create address modal and pass the customer to it.
   */
  public createBankData(): void {
    this.customerOverviewService.toggleAllModal(false);
    this.customerOverviewService.toggleCreateBankingDataModal(true);
  }

  /**
   * Checks the first indexed bank account
   */
  public defaultChecked(index: number): boolean {
    return index === 0;
  }
}
